import { render, staticRenderFns } from "./ContentParts.vue?vue&type=template&id=4115e6be&scoped=true&"
import script from "./ContentParts.vue?vue&type=script&lang=js&"
export * from "./ContentParts.vue?vue&type=script&lang=js&"
import style0 from "./ContentParts.vue?vue&type=style&index=0&id=4115e6be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4115e6be",
  null
  
)

export default component.exports